<template>
  <div class="staffing-container">
    <div class="title">
      <label v-if="viewMode === 'create'">新增員工</label>
      <label v-if="viewMode === 'edit'">編輯員工</label>
    </div>
    <div class="detail-container">
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="150px"
        class="demo-ruleForm"
      >
        <!-- 创建 -->
        <div v-if="viewMode === 'create'">
          <el-row
            v-for="(item, i) in ruleForm.roleIDList"
            :key="i"
            class="w600"
          >
            <el-col :span="14">
              <el-form-item
                label="所屬組別："
                :prop="'roleIDList.' + i + '.departmentID'"
                :rules="rules.department"
              >
                <el-cascader
                  ref="cascader"
                  v-model="item.departmentID"
                  filterable
                  placeholder="輸入搜尋/下拉選擇"
                  :options="organizationOptions"
                  expand-trigger="hover"
                  :props="{
                    children: 'childNode',
                    value: 'departmentID',
                    label: 'departmentName',
                    checkStrictly: true,
                    emitPath: false
                  }"
                  :show-all-levels="false"
                  class="w160"
                  @change="handleChange('department')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                label="角色："
                label-width="70px"
                :prop="'roleIDList.' + i + '.roleID'"
                :rules="rules.role"
              >
                <el-select
                  v-model="item.roleID"
                  placeholder="請選擇"
                  class="w180"
                  @change="handleChange('role')"
                >
                  <el-option
                    v-for="item in roleOptions"
                    :key="item.roleID"
                    :label="item.roleName"
                    :value="item.roleID"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-tooltip v-if="i == 0" placement="top" content="新增更多角色">
                            <el-button class="actionRow" icon="el-icon-plus" circle @click="addRow">1</el-button>
                        </el-tooltip>
                        <el-tooltip v-else placement="top" content="刪除">
                            <el-button class="actionRow" icon="el-icon-minus" circle @click="deleteRow(item, i)">1</el-button>
                        </el-tooltip>
                        <el-tooltip v-if="i == 0 && ruleForm.roleIDList.length >1" placement="top" content="新增更多角色">
                            <el-button class="actionRowDel" icon="el-icon-minus" circle @click="deleteRow(item, i)">1</el-button>
                        </el-tooltip> -->
            <el-tooltip
              v-if="i == 0"
              placement="top"
              content="新增更多角色"
            >
              <el-button
                class="actionRow"
                icon="el-icon-plus"
                circle
                @click="addRow"
              />
            </el-tooltip>
            <el-tooltip
              v-else
              placement="top"
              content="刪除"
            >
              <el-button
                class="actionRow"
                icon="el-icon-minus"
                circle
                @click="deleteRow(item, i)"
              />
            </el-tooltip>
          </el-row>
        </div>
        <!-- 修改 -->
        <div v-if="viewMode === 'edit'">
          <!-- 原有组织角色 -->
          <el-row
            v-for="(editItem, editIndex) in roleIDList"
            :key="editIndex"
            class="w600"
          >
            <div v-if="editItem.examine === 1">
              <el-row>
                <el-col :span="14">
                  <el-form-item
                    label="所屬組別："
                    :required="true"
                  >
                    <el-cascader
                      ref="cascader"
                      v-model="editItem.accountDepartmentID"
                      filterable
                      placeholder="輸入搜尋/下拉選擇"
                      :options="organizationOptions"
                      expand-trigger="hover"
                      :props="{
                        children: 'childNode',
                        value: 'departmentID',
                        label: 'departmentName',
                        checkStrictly: true,
                        emitPath: false
                      }"
                      :show-all-levels="false"
                      class="w160"
                      @change="handleChange(editIndex)"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item
                    label="角色："
                    label-width="70px"
                    :required="true"
                  >
                    <!-- 員工修改調整 -->
                    <!-- @change="handleChange(editIndex)" -->
                    <!-- <span> {{ editItem.roleID }}liulei{{ userInfo.roleID }}hh{{ editItem.examine }}</span> -->
                    <el-select
                      v-if="editItem.roleID === userInfo.roleID"
                      v-model="setRole"
                      placeholder="請選擇"
                      class="w180"
                    >
                      <el-option
                        v-for="(itemRole, index) in roleOptions"
                        :key="index.roleID"
                        :label="itemRole.roleName"
                        :value="itemRole.roleID"
                        @click.native="transferProperty(editItem, itemRole, editIndex)"
                      />
                    </el-select>
                    <!--   @change="handleChange(editIndex)" -->
                    <el-select
                      v-else
                      v-model="editItem.roleID"
                      placeholder="請選擇"
                      class="w180"
                    >
                      <el-option
                        v-for="(itemRole, index) in roleOptions"
                        :key="index.roleID"
                        :label="itemRole.roleName"
                        :value="itemRole.roleID"
                        @click.native="transferProperty(editItem, itemRole, editIndex)"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-tooltip
                  v-if="editIndex === 0 && (roleIDList.length > 1 || newRuleForm.newRoleIDList.length >= 1)"
                  placement="top"
                  content="刪除"
                >
                  <el-button
                    class="actionRowDel"
                    icon="el-icon-minus"
                    circle
                    @click="deleteRow(editItem, editIndex)"
                  />
                </el-tooltip>
                <el-tooltip
                  v-if="editIndex === 0"
                  placement="top"
                  content="新增更多角色"
                >
                  <el-button
                    class="actionRow"
                    icon="el-icon-plus"
                    circle
                    @click="addRow"
                  />
                </el-tooltip>
                <el-tooltip
                  v-else
                  placement="top"
                  content="刪除"
                >
                  <el-button
                    class="actionRow"
                    icon="el-icon-minus"
                    circle
                    @click="deleteRow(editItem, editIndex)"
                  />
                </el-tooltip>
                <!-- <el-tooltip v-if="editIndex === 0" placement="top" content="新增更多角色">
                                    <el-button class="actionRow" icon="el-icon-plus" circle @click="addRow">2</el-button>
                                </el-tooltip>
                                <el-tooltip v-else placement="top" content="刪除">
                                    <el-button class="actionRow" icon="el-icon-minus" circle @click="deleteRow(editItem, editIndex)">2</el-button>
                                </el-tooltip> -->
              </el-row>
            </div>
            <!-- 禁用修改 -->
            <div v-if="editItem.examine === 2">
              <el-row>
                <el-col :span="14">
                  <el-form-item
                    label="所屬組別："
                    :required="true"
                  >
                    <el-input
                      v-model="editItem.departmentName"
                      class="w160"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item
                    label="角色："
                    label-width="70px"
                    :required="true"
                  >
                    <el-input
                      v-model="editItem.roleName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-tooltip
                  v-if="editIndex === 0"
                  placement="top"
                  content="新增更多角色"
                >
                  <el-button
                    class="actionRow"
                    icon="el-icon-plus"
                    circle
                    @click="addRow"
                  />
                </el-tooltip>
                <el-tooltip
                  v-else
                  placement="top"
                  content="刪除"
                >
                  <el-button
                    class="actionRow"
                    icon="el-icon-minus"
                    circle
                    disabled
                  />
                </el-tooltip>
              </el-row>
            </div>
          </el-row>
          <!-- 新增添加 组织角色 -->
          <div v-if="showRow === true">
            <el-form
              ref="newRuleForm"
              :model="newRuleForm"
              :rules="newRules"
              label-width="150px"
              class="demo-ruleForm"
            >
              <el-row
                v-for="(itemRow, indexRow) in newRuleForm.newRoleIDList"
                :key="indexRow"
                class="w600"
              >
                <el-col :span="14">
                  <el-form-item
                    label="所屬組別："
                    :prop="'newRoleIDList.' + indexRow + '.accountDepartmentID'"
                    :rules="newRules.department"
                  >
                    <el-cascader
                      ref="cascader"
                      v-model="itemRow.accountDepartmentID"
                      filterable
                      placeholder="輸入搜尋/下拉選擇"
                      :options="organizationOptions"
                      expand-trigger="hover"
                      :props="{
                        children: 'childNode',
                        value: 'departmentID',
                        label: 'departmentName',
                        checkStrictly: true,
                        emitPath: false
                      }"
                      :show-all-levels="false"
                      class="w160"
                      @change="newHandleChange"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item
                    label="角色："
                    label-width="70px"
                    :prop="'newRoleIDList.' + indexRow + '.roleID'"
                    :rules="newRules.role"
                  >
                    <el-select
                      v-model="itemRow.roleID"
                      placeholder="請選擇"
                      class="w180"
                      @change="newHandleChange"
                    >
                      <el-option
                        v-for="itemRow in roleOptions"
                        :key="itemRow.roleID"
                        :label="itemRow.roleName"
                        :value="itemRow.roleID"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- <el-tooltip v-if="indexRow === null" placement="top" content="新增更多角色">
                                    <el-button class="actionRow" icon="el-icon-plus" circle @click="addRow">4{{indexRow}}</el-button>
                                </el-tooltip>
                                <el-tooltip v-else placement="top" content="刪除">
                                    <el-button class="actionRow" icon="el-icon-minus" circle @click="deleteRow(itemRow, indexRow)">4{{indexRow}}</el-button>
                                </el-tooltip> -->
                <el-tooltip
                  v-if="indexRow === 0 && roleIDList.length === 0"
                  placement="top"
                  content="新增更多角色"
                >
                  <el-button
                    class="actionRow"
                    icon="el-icon-plus"
                    circle
                    @click="addRow"
                  />
                </el-tooltip>
                <!-- 删除按钮存在的三种情况 -->
                <!--
                                    1.存在原角色,新增员工显示删除
                                    2.不存在原角色,存在1个以上新增角色,第一个新增的角色可以显示删除
                                    3.无论是否存在原角色,只要不是第一个新增的角色都有删除
                                 -->
                <el-tooltip
                  v-if="indexRow == 0 && roleIDList.length !== 0"
                  placement="top"
                  content="刪除"
                >
                  <el-button
                    class="actionRow"
                    icon="el-icon-minus"
                    circle
                    @click="deleteRow(itemRow, indexRow)"
                  />
                </el-tooltip>
                <el-tooltip
                  v-if="indexRow !== 0"
                  placement="top"
                  content="刪除"
                >
                  <el-button
                    class="actionRow"
                    icon="el-icon-minus"
                    circle
                    @click="deleteRow(itemRow, indexRow)"
                  />
                </el-tooltip>
                <el-tooltip
                  v-if="newRuleForm.newRoleIDList.length > 1 && indexRow == 0 && roleIDList.length == 0"
                  placement="top"
                  content="刪除"
                >
                  <el-button
                    :class="['actionRow', { actionRowDel: indexRow === 0 && roleIDList.length === 0 }]"
                    icon="el-icon-minus"
                    circle
                    @click="deleteRow(itemRow, indexRow)"
                  />
                </el-tooltip>
              </el-row>
            </el-form>
          </div>
        </div>
        <el-form-item
          label="姓名："
          class="w600"
          prop="name"
        >
          <el-input
            v-model="ruleForm.name"
            maxlength="40"
            show-word-limit
          />
        </el-form-item>
        <el-form-item
          label="是否為代理人："
          class="w600"
        >
          <el-radio-group v-model.trim="ruleForm.isAgent">
            <el-radio :label="true">
              是
            </el-radio>
            <el-radio :label="false">
              否
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="聯絡電話："
          class="w600"
          prop="telephone"
        >
          <el-select
            v-model="ruleForm.phoneCode"
            class="w84"
            :disabled="viewMode === 'edit' && companyCategory == 1"
            placeholder="+852"
            filterable
            no-data-text="暫無數據"
            @change="isDifferentPhone"
          >
            <el-option
              v-for="(item,index) in codeList"
              :key="index+3"
              :label="item.codeText"
              :value="item.code"
            />
          </el-select>
          <el-input
            v-model.trim="ruleForm.telephone"
            class="winput"
            :disabled="viewMode === 'edit' && companyCategory == 1"
            @blur="isDifferentPhone"
          />
          <el-checkbox
            v-model.trim="ruleForm.isShowWhatsApp"
            class="wcheck"
            :disabled="companyCategory == 1"
            @change="isDifferentPhone"
          >
            聯絡電話與WhatsApp號碼相同
          </el-checkbox>
        </el-form-item>
        <el-form-item
          label="WhatsApp號碼"
          class="w600"
          prop="whatsApp"
        >
          <el-select
            v-model="ruleForm.whatsAppCode"
            class="w84"
            :disabled="ruleForm.isShowWhatsApp"
            placeholder="+852"
            filterable
            no-data-text="暫無數據"
          >
            <el-option
              v-for="(item,index) in codeList"
              :key="index+3"
              :label="item.codeText"
              :value="item.code"
            />
          </el-select>
          <el-input
            v-model.trim="ruleForm.whatsApp"
            class="winput"
            :disabled="ruleForm.isShowWhatsApp"
          />
        </el-form-item>
        <!-- <el-form-item class="w600">
                    <div>
                        <el-checkbox v-model.trim="ruleForm.isShowWhatsApp">可WhatsApp</el-checkbox>
                        <el-checkbox name="weChatCheck" v-model="ruleForm.isShowWeChat">可WeChat</el-checkbox>
                    </div>
                </el-form-item> -->
        <el-form-item
          label="電郵："
          class="w600"
          :required="isHaveTo"
          prop="email"
        >
          <el-input
            v-model.trim="ruleForm.email"
            :disabled="disEmail"
            maxlength="60"
          />
          <!-- <el-input v-if="viewMode === 'edit' && detail.email !== '' && detail.email !== null && detail.email !== undefined" disabled v-model.trim="detail.email" maxlength="60"></el-input>
                    <el-input v-else v-model.trim="ruleForm.email" maxlength="60"></el-input> -->
          <span
            v-show="repeatEmail"
            class="span_errtxt"
          >{{ ruleForm.email }}<br>該電郵地址已註冊，請使用其他電郵地址</span>
        </el-form-item>
        <el-form-item
          v-if="viewMode === 'edit'"
          label="員工狀態："
          class="w600"
          prop="status"
        >
          <el-radio-group
            v-model="ruleForm.status"
            @change="updtaeStatus"
          >
            <el-radio label="Normal">
              啟用
            </el-radio>
            <el-radio label="Disable">
              停用
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 代理信息 -->
        <div
          v-if="ruleForm.isAgent === true"
          class="isAgent"
        >
          <div class="privateHeight">
            <el-form-item
              :label="'國內聯絡電話：\n (毋須填86)  '"
              class="w601"
              prop="customerTel"
            >
              <el-input
                v-model.trim="ruleForm.customerTel"
                maxlength="11"
              />
            </el-form-item>
          </div>
          <!-- 微信qrcode 微信号 -->
          <el-form-item
            label="WeChat號："
            class="w600"
            prop="weChatNo"
          >
            <el-input
              v-model.trim="ruleForm.weChatNo"
              show-word-limit
              maxlength="20"
              @blur="changeWeCharNo"
            />
          </el-form-item>
          <el-form-item
            label="WeChat二維碼："
            class="w600"
            prop="weChatcode"
          >
            <el-input
              v-show="false"
              v-model="ruleForm.weChatQRCode"
            />
            <el-row>
              <el-col :span="5">
                <div
                  :class="['avatar-uploader',!ruleForm.weChatNo || ruleForm.weChatNo.length<6 || ruleForm.weChatNo.length>20 ? 'none':'' ] "
                  @click="beforeAvatarUpload('weChatQRCode')"
                >
                  <img
                    v-if="ruleForm.weChatQRCode"
                    :src="pub.imgResize(ruleForm.weChatQRCode, 'user')"
                    class="avatar"
                  >
                  <i
                    v-else
                    class="el-icon-plus avatar-uploader-icon"
                  />
                </div>
              </el-col>
              <el-col :span="18">
                <label :class="['photoTip', 'explain']">
                  <p>輸入WeChat號，請同步上傳WeChat二維碼</p>
                  <br>
                  <p>支援格式：JPG, JPEG, PNG）</p>
                </label>
              </el-col>
            </el-row>
          </el-form-item>
          <template v-if="!isUseHideAgentLicensePlate">
            <el-form-item
              label="個人地產代理牌照："
              class="w600"
              prop="license"
            >
              <el-input
                v-model.trim="ruleForm.license"
                placeholder="代理牌照格式為：E-123456 / S-123456"
                show-word-limit
                maxlength="40"
              />
            </el-form-item>
            <el-form-item
              label=" 上傳代理證："
              class="w600"
              prop="agentCardPath"
            >
              <el-input
                v-show="false"
                v-model="ruleForm.agentCardPath"
              />
              <el-row>
                <el-col :span="5">
                  <div
                    :class="['avatar-uploader'] "
                    @click="beforeAvatarUpload('agentCardPath')"
                  >
                    <img
                      v-if="ruleForm.agentCardPath"
                      :src="pub.imgResize(ruleForm.agentCardPath, 'user')"
                      class="avatar"
                    >
                    <i
                      v-else
                      class="el-icon-plus avatar-uploader-icon"
                    />
                  </div>
                </el-col>
                <el-col :span="18">
                  <label :class="['photoTip', 'explain']">
                    <p>支援格式：JPG, JPEG, PNG）</p>
                  </label>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item
              label=" 地產牌照屆滿日期"
              class="w600"
              prop="agentCardExpireTime"
            >
              <el-date-picker
                v-model="ruleForm.agentCardExpireTime"
                format="yyyy/MM/dd"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="請選擇日期"
              />
            </el-form-item>
          </template>

          <el-form-item
            label="個人頭像："
            class="w600"
            prop="imagePath"
          >
            <el-input
              v-show="false"
              v-model="ruleForm.imagePath"
            />
            <el-row>
              <el-col :span="5">
                <div
                  class="avatar-uploader"
                  @click="beforeAvatarUpload('userImage')"
                >
                  <img
                    v-if="ruleForm.imagePath"
                    :src="pub.imgResize(ruleForm.imagePath, 'user')"
                    class="avatar"
                  >
                  <i
                    v-else
                    class="el-icon-plus avatar-uploader-icon"
                  />
                </div>
              </el-col>
              <el-col :span="16">
                <label :class="['photoTip', 'explain']">
                  <p>上傳代理頭像、公司標誌或卡片可增加客戶信心</p>
                  <br>
                  <p>支援格式：jpg，jpeg，png</p>
                  <p>圖片大小：不限</p>
                </label>
              </el-col>
            </el-row>
          </el-form-item>
          <div class="privateHeight">
            <el-form-item
              label="代理個人署名或特別服務："
              class="w601"
            >
              <el-input
                v-model="ruleForm.signature"
                :rows="3"
                maxlength="200"
                type="textarea"
              />
              <label class="photoTip">輸入限制200字</label>
            </el-form-item>
          </div>
        </div>
        <div class="btn">
          <!-- :loading="disablePost" {{ disablePost ? '提交中' : '儲存' }} -->
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
          >
            儲存
          </el-button>
          <el-button @click="getBack">
            返回
          </el-button>
        </div>
      </el-form>
    </div>
    <!-- 修改头像弹窗 -->
    <div v-if="openAvatar">
      <el-dialog
        v-loading="loadingAvatar"
        :title="titleAvatar"
        :visible.sync="openAvatar"
        width="480px"
      >
        <div slot="default">
          <AvatarCropper
            ref="upImg"
            :up-source="upSource"
            @changeDis="changeDis"
            @getFileData="synchronizeAvatar"
          />
        </div>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="closeAvatarDialog">取 消</el-button>
          <el-button
            type="primary"
            :disabled="showBtn"
            @click="uploadAvatar"
          >確認</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 转移楼盘弹窗 -->
    <el-dialog
      title="請選擇管理員賬戶"
      width="600px"
      class="edit-text-show"
      :visible.sync="isTransferProperty"
      @close="cancelEditRole()"
    >
      <el-row class="el-row-dialog">
        <el-col :span="4">
          選項
        </el-col>
        <el-col :span="8">
          員工姓名
        </el-col>
        <el-col :span="12">
          組別
        </el-col>
      </el-row>
      <el-row
        v-for="item in adminList"
        :key="item.accountID"
        class="el-list"
      >
        <div
          v-if="item.status == 'Normal' && item.accountID != userDetail.accountID"
          class="el-list-div"
        >
          <el-col :span="4">
            <el-checkbox
              :value="recevieAccountID == item.accountID"
              @click.native="recevieAccountID = item.accountID"
            />
          </el-col>
          <el-col :span="8">
            {{ item.name }}
          </el-col>
          <el-col :span="12">
            <p>{{ getRequiredRole(item.roleList, 'departmentName') }}</p>
            <p>{{ getRequiredRole(item.roleList, 'roleName') }}</p>
          </el-col>
        </div>
      </el-row>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="cancelEditRole()">
          取 消
        </el-button>
        <el-button
          type="primary"
          @click="transferPropertyToAdmin()"
        >
          確 認
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import AvatarCropper from '../../../components/AvatarCropper/index';
export default {
    components: { AvatarCropper },
    props: {
        // 显示模式
        viewMode: {
            type: String,
            default: 'view'
        }
    },
    computed: {
        ...mapGetters(['userInfo']),
        isHaveTo: function () {
            // 营业助理电邮皆非必填
            return this.chushijin === true || (this.ruleForm.isAgent === false && this.checkNoAgent === true) || (this.ruleForm.isAgent === true && this.checkNoAgent === true) || this.mustEmail == true;
        },
        imageUrl() {
            return this.pub.getApi().Upload;
        }
    },
    data() {
        // 电话
        let telephone = (rule, value, callback) => {
            let eArr = ['853','65']
            let nArr = ['886','66','60','61']
            let tArr = ['81','1','44']
            let regExp = ''
            if(this.ruleForm.phoneCode == '852'){
                regExp = /^[2-9]\d{7}$/;
            }else if(this.ruleForm.phoneCode == '86'){
                regExp = /^1[3|4|5|7|8|6|9][0-9]\d{8}$/;
            }else if(eArr.includes(this.ruleForm.phoneCode) ){
                regExp = /^\d{8}$/
            }else if(nArr.includes(this.ruleForm.phoneCode)){
                regExp = /^\d{9}$/
            }else if(tArr.includes(this.ruleForm.phoneCode)){
                regExp = /^\d{10}$/
            }
            if (!value) {
                return callback(new Error('請輸入電話號碼'));
            } else if (regExp && !regExp.test(value)) {
                return callback(new Error('請輸入正確的電話號碼'));
            }
                callback();

        };
        let whatsApp = (rule, value, callback) => {
            let eArr = ['853','65']
            let nArr = ['886','66','60','61']
            let tArr = ['81','1','44']
            let regExp = ''
            if(this.ruleForm.whatsAppCode == '852'){
                regExp = /^[2-9]\d{7}$/;//hk
            }else if(this.ruleForm.whatsAppCode == '86'){
                regExp = /^1[3|4|5|7|8|6|9][0-9]\d{8}$/; //大陆
            }else if(eArr.includes(this.ruleForm.whatsAppCode) ){
                regExp = /^\d{8}$/
            }else if(nArr.includes(this.ruleForm.whatsAppCode)){
                regExp = /^\d{9}$/
            }else if(tArr.includes(this.ruleForm.whatsAppCode)){
                regExp = /^\d{10}$/
            }
            if (value !== '' && value !== null && value != undefined && regExp && !regExp.test(value)) {
                return callback(new Error('請輸入正確的WhatsApp號碼'));
            }
                callback();

        };
        // 代理牌照校验
        let license = (rule, value, callback) => {
            let regExp = /^[E|S]-\d{6}$/;
            if (!value) {
                return callback(new Error('請輸入個人地產代理牌照'));
            } else if (!regExp.test(value) && value !== '--') {
                return callback(new Error('請按照格式正確輸入個人地產代理牌照'));
            }
                callback();

        };
        // 電郵
        let email = (rule, value, callback) => {
            if (this.isHaveTo && (!value || value === '')) {
                return callback(new Error('請輸入電郵'));
            }
                this.required = false;
                callback();

        };

        let weChatcode = (rule, value, callback) => {
            if (!this.ruleForm.weChatQRCode && this.ruleForm.weChatNo && this.ruleForm.weChatNo.length >=6 && this.ruleForm.weChatNo.length<=20) {
                return callback(new Error('請上傳WeChat二維碼'));
            }
                callback();

        };
        let weChatNo = (rule, value, callback) => {
            if (value && value.length && (value.length < 6 || value.length > 20)) {
                return callback(new Error('WeChat號長度限6-20位'));
            }
                callback();

        };
        let agentCardExpireTime = (rule, value, callback) => {
            if (value === '0001-01-01T00:00:00' || !value) {
                callback(new Error('請選擇地產牌照屆滿日期'));
            } else {
                callback();
            }
        };
        // 國內電話驗證
        let customerTel = (rule, value, callback) => {
            let regExp = /^1[3|4|5|7|8|6|9][0-9]\d{8}$/;
            if (value !== '' && value !== null && value != undefined && !regExp.test(value)) {
                return callback(new Error('手機號碼格式不正確'));
            }
                callback();

        };
        return {
            repeatEmail:false,
            disEmail:false,
            upSource:'userImage',
            // disablePost: false,
            showFlag: false,
            accountType: false,
            // disablePost: false,
            chushijin: true,
            mustEmail: false,
            isYingye: false,
            showBtn: false,
            isTransferSuccess: false,
            // 接收人賬戶id
            recevieAccountID: '',
            // 修改轉移角色權限列表索引
            editTransferIndex: '',
            // 當前選擇組織id
            accountDepartmentID: '',
            // 楼盘转移管理员列表
            adminList: [],
            // 修改角色权限转移楼盘弹窗
            isTransferProperty: false,
            fileName: '',
            titleAvatar: '上傳頭像',
            wechatAvatar:'上傳WeChat二維碼',
            openAvatar: false,
            loadingAvatar: false,
            fileUrl: null,
            checkNoAgent: false,
            isPass: true,
            detail: {},
            check: false,
            department: false,
            role: false,
            userDetail: {},
            departments: [],
            newRuleForm: {
                newRoleIDList: []
            },
            showRow: false,
            show: false,
            aaaa: null,
            successUrl: '',
            organizationOptions: [],
            roleIDList: [],
            roleOptions: [],
            departmentID: 0,
            radio: '',
            deleteUser: {},
            companyCategory: null,
            codeList:[],
            ruleForm: {
                whatsAppCode:'852',
                phoneCode:'852',
                accountID: '',
                email: '',
                roleIDList: [
                    {
                        roleID: null,
                        departmentID: null
                    }
                ],
                isAgent: false,
                status: 'Normal',
                name: '',
                nameEN: '',
                whatsApp: '',
                telephone: '',
                license: '',
                customerTel: '',
                weChatNo:'',
                weChatQRCode:'',
                agentCardPath:'',
                agentCardExpireTime:'',
                imagePath: '',
                signature: '',
                isShowWhatsApp: true,
                isShowWeChat: false,
                setRole: ' '
            },
            rules: {
                name: [{ required: true, message: '請輸入姓名', trigger: 'blur' }],
                email: [
                    { required: false, validator: email },
                    {
                        type: 'email', //要检验的类型（number，email，date等）
                        message: '請輸入正確的郵箱地址',
                        trigger: ['blur']
                    }
                ],
                agentCardExpireTime:[{required: true,trigger: 'blur' ,validator: agentCardExpireTime,}],
                agentCardPath:[{required: true, message: '請上傳代理證', trigger: 'change'}],
                whatsApp: [{ validator: whatsApp, trigger: ['blur', 'change'] }],
                telephone: [{ required: true, validator: telephone, trigger: ['blur', 'change'] }],
                department: [{ required: true, message: '請選擇組別', trigger: 'change' }],
                role: [{ required: true, message: '請選擇角色', trigger: 'change' }],
                imagePath: [{ required: true, message: '請上傳頭像', trigger: 'change' }],
                license: [
                    {
                        required: true,
                        // message: '請输入個人地產代理牌照',
                        trigger: 'blur',
                        validator: license
                    }
                ],
                weChatNo:[{required: false, validator: weChatNo, trigger: 'blur'}],
                weChatcode:[{required: false,validator: weChatcode, trigger: 'change'}],
                customerTel: [{ required: false, validator: customerTel, trigger: 'blur' }]
            },
            newRules: {
                department: [{ required: true, message: '請選擇組別', trigger: 'change' }],
                role: [{ required: true, message: '請選擇角色', trigger: 'change' }]
            }
        };
    },
    watch: {
        // 监听checkNoAgent变化
        checkNoAgent: {
            handler() {
                this.isHaveTo;
            }
        }
    },
    async created() {
        // 获取公司配置
        await this.GetCompanyCofig();
        // 获取组织列表
        this.getOrganizationOptions();
        // 获取角色列表
        this.getRoleOptions();
        this.getPhoneCodeInfo()
        // 加载数据
        if (this.viewMode === 'edit' || this.viewMode === 'view') {
            // 編輯模式
            this.setRole = this.userInfo.roleName;
            // localStorage获取详情数据
            this.userDetail = JSON.parse(localStorage.getItem('userDetail'));
            this.detail = JSON.parse(JSON.stringify(this.userDetail));
            this.roleIDList = this.userDetail.roleList;
            this.ruleForm.accountID = this.userDetail.accountID;
            this.ruleForm.email = this.userDetail.email;
            this.ruleForm.isAgent = this.userDetail.isAgent;
            this.ruleForm.whatsApp = this.userDetail.whatsApp;
            this.ruleForm.telephone = this.userDetail.telephone;
            // this.ruleForm.isShowWeChat = this.userDetail.isShowWeChat;
            // this.ruleForm.isShowWhatsApp = this.userDetail.telephone == this.userDetail.whatsApp && this.companyCategory != 1 ? true : false;
            this.ruleForm.isShowWhatsApp = this.userDetail.isShowWhatsApp && this.companyCategory != 1 ? true : false;
            this.ruleForm.signature = this.userDetail.signature;
            this.ruleForm.weChatNo = this.userDetail.weChatNo;
            this.ruleForm.customerTel = this.userDetail.customerTel;
            this.ruleForm.license = this.userDetail.license;
            this.ruleForm.name = this.userDetail.name;
            // bugfix管理后台新增员工 会出现空区号问题
            this.ruleForm.phoneCode = this.userDetail.phoneCode == null?'852':this.userDetail.phoneCode
            this.ruleForm.whatsAppCode = this.userDetail.whatsAppCode == null?'852':this.userDetail.whatsAppCode
            this.ruleForm.imagePath = this.userDetail.imagePath;
            this.ruleForm.weChatQRCode = this.userDetail.weChatQRCode;
            this.ruleForm.agentCardPath = this.userDetail.agentCardPath;
            this.ruleForm.status = this.userDetail.status;
            // this.ruleForm.agentCardExpireTime = this.userDetail.agentCardExpireTime
            this.ruleForm.agentCardExpireTime = this.userDetail.agentCardExpireTime.indexOf('0001-01-01')? this.userDetail.agentCardExpireTime: '';
            this.check = this.userDetail.status;
            // 判断邮箱禁用权限 : 1.总行管理员可以修改除总行管理员外所有人的邮箱.2.分行管理员仅支持修改"只有一个角色，且俩人在同一个分行"人的邮箱
            this.disEmail = false //true 邮箱禁止修改
            if(this.ruleForm.email && this.ruleForm.email !== '' && this.ruleForm.email !== null && this.ruleForm.email !== undefined){
                if(this.userInfo.roleID == 1){
                    for (let i = 0; i < this.roleIDList.length; i++) {
                        if(this.roleIDList[i].roleID == 1){
                            // 禁用
                            this.disEmail = true;
                            break
                        }
                    }
                }else if(this.userInfo.roleID == 2){
                    if(this.roleIDList.length > 1){
                        this.disEmail = true;
                    }else{
                        this.disEmail =  this.roleIDList[0].accountDepartmentID == this.userInfo.departmentID ? false: true;
                    }
                }else{
                    this.disEmail = false
                }
            }else{
                this.disEmail = false
            }

        }
        if (this.companyCategory == 1) {
            this.ruleForm.isShowWhatsApp = false;
        }
        // 营业助理 修改页初始进入,电邮非必填  || this.ruleForm.email && (!this.ruleForm.email || this.ruleForm.email)
        if (this.roleIDList) {
            for (let i = 0; i < this.roleIDList.length; i++) {
                if (this.roleIDList[i].roleID == 4) {
                    this.checkNoAgent = false;
                    this.chushijin = false;
                }
            }
        }
    },
    methods: {
        getPhoneCodeInfo(){
            return this.axios.get(this.pub.getApi().GetPhoneCodeInfo).then(res => {
                this.codeList = res.data.result;
            });
        },
        changeWeCharNo(){
            if(this.ruleForm.weChatNo == ''){
                this.ruleForm.weChatQRCode = ''
            }
        },
        isDifferentPhone() {
            // this.ruleForm.telephone &&
            if (this.ruleForm.isShowWhatsApp) {
                this.ruleForm.whatsApp = this.ruleForm.telephone;
                this.ruleForm.whatsAppCode = this.ruleForm.phoneCode
            }
        },
        GetCompanyCofig() {
            return this.axios.get(this.pub.getApi().GetCompanyCofig).then(res => {
                // true则是公司账户
                this.accountType = res.data.result.accountType;
                this.companyCategory = res.data.result.companyCategory; //1.中原 2.李嘉格 3.普通用户
                this.isUseHideAgentLicensePlate = res.data.result.isUseHideAgentLicensePlate
            });
        },
        // 轉移樓盤給管理員
        transferPropertyToAdmin() {
            if (!this.recevieAccountID) {
                this.isTransferProperty = false;
                return;
            }
            if (this.userDetail.accountID == this.recevieAccountID) {
                this.$message({
                    type: 'warning',
                    message: '樓盤不能轉移給自己！',
                    showClose: true
                });
                this.isTransferProperty = false;
            } else {
                // 調取接口轉移樓盤
                this.axios
                    .post(this.pub.getApi().UpdatePropertyAllOwner, {
                        accountID: this.userDetail.accountID,
                        departmentID: this.accountDepartmentID,
                        recevieAccountID: this.recevieAccountID
                    })
                    .then(res => {
                        if (res.data.code == 0 && res.data.result) {
                            this.isTransferSuccess = true;
                            this.isTransferProperty = false;
                            this.$message({
                                type: 'success',
                                message: '樓盤轉移成功',
                                showClose: true
                            });
                        } else {
                            this.isTransferProperty = false;
                            this.$message({
                                type: 'warning',
                                message: '樓盤轉移失敗',
                                showClose: true
                            });
                        }
                    });
            }
        },
        // 轉移樓盤是取消修改
        cancelEditRole() {
            if (this.isTransferSuccess) {return;}
            let index = this.editTransferIndex;
            this.isTransferProperty = false;
            this.roleIDList[index].roleID = this.detail.roleList[index].roleID;
            this.setRole = this.detail.roleList[index].roleName;
            this.isTransferSuccess = false;
        },
        // 選擇轉移樓盤管理員時展示當前組織權限
        getRequiredRole(data, type) {
            if (!data || !data.length) {return;}
            let roleName = '';
            let departmentName = '';
            data.forEach(item => {
                if (item.accountDepartmentID == this.accountDepartmentID) {
                    type == 'roleName' ? (roleName = item.roleName) : (departmentName = item.departmentName);
                }
            });
            return type == 'roleName' ? roleName : departmentName;
        },
        // 修改用户角色权限 转移楼盘
        transferProperty(data, itemDate, index) {
            // 登录角色和要修改的角色是同一个的时候,分行管理员将自己改为放盘人时候,角色不变bug
            // this.setRole =itemDate.roleName;
            // this.roleIDList[index].roleID = itemDate.roleID;
            // 修改员工liu
            if (this.accountType && (this.userInfo.roleID == 1 || this.userInfo.roleID == 2)) {
                // 由放盘人改为管理员时
                if ((data.roleName == '營業助理' || data.roleName == '放盤人') && (itemDate.roleName == '總行管理員' || itemDate.roleName == '分行管理員')) {
                    if (this.roleIDList[index].remainderDiamond != 0 || this.roleIDList[index].remainderPropertyCoin != 0) {
                        this.$confirm('確認修改為【分行管理員】後，原有角色的金幣/鑽石將會回收到公司賬戶', '確認修改角色？', {
                            confirmButtonText: '確認',
                            cancelButtonText: '取消',
                            type: 'warning'
                        })
                            .then(() => {
                                // 保存當前組織id
                                this.accountDepartmentID = data.accountDepartmentID;
                            })
                            .catch(() => {
                                // 取消時不改變角色選項
                                this.roleIDList[index].roleID = this.detail.roleList[index].roleID;
                                this.setRole = this.detail.roleList[index].roleName;
                            });
                    }
                }
            }
            let _del = this.userDetail;
            // 营业助理转为放盘人时没有邮箱需要增加邮箱!
            if (this.detail.email == '' && data.roleName == '營業助理' && (itemDate.roleName == '放盤人' || itemDate.roleName == '分行管理員')) {
                this.mustEmail = true;
                this.isYingye = true;
            } else if (this.detail.email == '' && itemDate.roleName == '營業助理' && (data.roleName == '放盤人' || data.roleName == '分行管理員')) {
                //老数据 存在放盘人无邮箱 当放盘转营业助理,需要邮箱改为非必填
                this.mustEmail = false;
                this.chushijin = false;
            } else {
                this.mustEmail = false;
            }
            // 只要現在是 放盤人或者管理員 就得必填
            if (data.roleID == '2' || data.roleID == '3') {
                this.mustEmail = true;
            }
            if (itemDate.roleID == 4) {
                this.ruleForm.isAgent = true;
            }
            // 查看是否需要转移楼盘 判断是否是"營業助理"，是否有自己的楼盘
            if (itemDate.roleID != 4) {return;}
            this.editTransferIndex = index;
            this.recevieAccountID = '';
            this.$confirm('確認修改為【營業助理】後，原有角色所屬的樓盤將會分配到管理員賬戶', '確認修改角色？', {
                confirmButtonText: '確認',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    // 保存當前組織id
                    this.accountDepartmentID = data.accountDepartmentID;
                    // 发送请求判断是否有代理楼盘
                    this.axios
                        .post(this.pub.getApi().UserDepartmentCionPropertyCount, {
                            accountID: _del.accountID,
                            departmentID: data.accountDepartmentID
                        })
                        .then(res => {
                            let _res = res.data.result;
                            if (res.data.code == 0 && _res) {
                                // 当前角色下无楼盘数据 无需转移
                                if (!_res.propertyCount && !_res.agentPropertyCount) {return;}
                                // 获取管理员列表 總行管理 1，分行管理 2，roleid寫死了
                                this.axios
                                    .post(this.pub.getApi().SearchDistinctOrganizationUserInfo, {
                                        roleIdList: [1, 2],
                                        departmentID: data.accountDepartmentID,
                                        pageIndex: 1,
                                        pageCount: 100
                                    })
                                    .then(resdata => {
                                        let _resdata = resdata.data.result;
                                        if (resdata.data.code == 0 && _resdata) {
                                            this.adminList = _resdata.data;
                                            // 打開轉移樓盤 管理員列表
                                            this.isTransferProperty = true;
                                        }
                                    });
                            }
                        });
                })
                .catch(() => {
                    // 取消時不改變角色選項
                    this.roleIDList[index].roleID = this.detail.roleList[index].roleID;
                    this.setRole = this.detail.roleList[index].roleName;
                });
        },
        // 上传图片头像
        synchronizeAvatar(data, fileName) {
            this.fileUrl = data;
            this.fileName = fileName;
        },
        changeDis(a) {
            this.showBtn = a;
        },
        // 取消上传图片弹窗
        closeAvatarDialog() {
            this.openAvatar = false;
            this.fileUrl = null;
            this.$refs.upImg.resetFile();
        },
        // 获取組別下拉数据
        getOrganizationOptions() {
            var _this = this;
            _this.axios
                .get(_this.pub.getApi().GetDepartmentsTreeByParentID, {
                    params: {
                        departmentID: _this.userInfo.departmentID
                    }
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        _this.organizationOptions.push(res.data.result);
                    }
                });
        },
        // 获取角色下拉数据
        getRoleOptions() {
            this.axios.get(this.pub.getApi().SerachChildRoleInfoByParentRoleID + `?parentRoleID=${this.userInfo.roleID}`).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    // 过滤同级
                    var me = this;
                    me.roleOptions = res.data.result;
                    for (let index = 0; index < me.roleOptions.length; index++) {
                        if (me.roleOptions[index].roleID === me.userInfo.roleID) {me.roleOptions.splice(index, 1);}
                    }
                }
            });
        },
        // 储存数据 添加或者修改
        submitForm(formName) {
            this.$refs['ruleForm'].validate(valid => {
                // this.disablePost = true;
                if (valid) {
                    /* 個人代理牌照大寫轉化 */
                    if (this.ruleForm.license) {
                        this.ruleForm.license = this.ruleForm.license.toUpperCase();
                    }
                    if (this.viewMode === 'create') {
                        for (var i = 0; i < this.ruleForm.roleIDList.length; i++) {
                            for (var j = i + 1; j < this.ruleForm.roleIDList.length; j++) {
                                if (this.ruleForm.roleIDList[i].departmentID == this.ruleForm.roleIDList[j].departmentID && this.ruleForm.roleIDList[i].departmentID !== null && this.ruleForm.roleIDList[j].departmentID !== null) {
                                    if (document.getElementsByClassName('el-message').length === 0) {
                                        this.$message({
                                            type: 'warning',
                                            message: '員工在一個組別中只能擁有一個角色,請重新選擇！',
                                            showClose: true
                                        });
                                    }
                                    // this.disablePost = false;
                                    return false;
                                }
                            }
                        }
                        const submitData = {
                          ...this.ruleForm,
                          // 如果 email 是 null/undefined，则赋予空字符串
                          email: this.ruleForm.email || '' 
                        };
                        this.axios.post(this.pub.getApi().AddUserInfo, submitData).then(res => {
                            if (res.data.code === 0 && res.data.result && res.data.message === null) {
                                // 不存在邮箱 不予以提示
                                if (this.ruleForm.email !== '') {
                                    const confirmText = ['新增成功', '首次登入密碼會以電郵通知'];
                                    const newDatas = [];
                                    const h = this.$createElement;
                                    try {
                                        // eslint-disable-next-line no-shadow
                                        for (const i in confirmText) {
                                            newDatas.push(h('p', null, confirmText[i]));
                                        }
                                        this.$confirm('提示', {
                                            title: '提示',
                                            message: h('div', null, newDatas),
                                            showCancelButton: false,
                                            confirmButtonText: '確定',
                                            type: 'success'
                                        });
                                    } catch (e) {
                                        console.log('新增时提示报错', e);
                                    }
                                }
                                this.repeatEmail = false
                                // this.disablePost = false;
                                this.$router.push({ path: '/staffing/index' });
                                // history.back();
                            } else if (res.data.code === 1308) {
                                // this.disablePost = false;
                                if (document.getElementsByClassName('el-message').length === 0) {
                                    this.$nextTick(()=>{
                                        this.repeatEmail = true
                                        // this.$refs.ruleForm.validateField('email')
                                    })
                                    this.$message({
                                        type: 'error',
                                        message: `${this.ruleForm.email}該電郵地址已註冊，請使用其他電郵地址。`,
                                        showClose: true
                                    });
                                }
                            } else if (res.data.code === 0 && res.data.result && res.data.message) {
                                this.repeatEmail = false
                                if (document.getElementsByClassName('el-message').length === 0) {
                                    try {
                                        this.$confirm('提示', {
                                            title: '提示',
                                            message: res.data.message,
                                            showCancelButton: false,
                                            confirmButtonText: '確定',
                                            type: 'success'
                                        });
                                    } catch (e) {
                                        console.log('新增报错', e);
                                    }

                                    // this.disablePost = false;
                                    this.$router.push({ path: '/staffing/index' });
                                    // history.back();
                                }
                            }
                        });
                    } else if (this.viewMode === 'edit') {
                        let roles = [];
                        let newRows = [];
                        for (var item of this.roleIDList) {
                            let obj1 = {};
                            obj1.departmentID = item.accountDepartmentID;
                            obj1.roleID = item.roleID;
                            roles.push(obj1);
                        }
                        for (var itemIndex of this.newRuleForm.newRoleIDList) {
                            let obj2 = {};
                            obj2.departmentID = itemIndex.accountDepartmentID;
                            obj2.roleID = itemIndex.roleID;
                            newRows.push(obj2);
                        }
                        this.ruleForm.roleIDList = [];
                        this.ruleForm.roleIDList = roles.concat(newRows);
                        if (this.newRuleForm.newRoleIDList.length > 0) {
                            this.$refs['newRuleForm'].validate(validItem => {
                                if (validItem) {
                                    this.isPass = true;
                                } else {
                                    if (document.getElementsByClassName('el-message').length === 0) {
                                        this.$message({
                                            type: 'warning',
                                            message: '請完善信息!',
                                            showClose: true
                                        });
                                    }
                                    this.isPass = false;
                                }
                            });
                        }
                        if (this.ruleForm.roleIDList.length > 1) {
                            for (var i = 0; i < this.ruleForm.roleIDList.length; i++) {
                                for (var j = i + 1; j < this.ruleForm.roleIDList.length; j++) {
                                    var me = this;
                                    if (me.ruleForm.roleIDList[i].departmentID == me.ruleForm.roleIDList[j].departmentID && me.ruleForm.roleIDList[i].departmentID !== undefined && me.ruleForm.roleIDList[j].departmentID !== undefined) {
                                        if (document.getElementsByClassName('el-message').length === 0) {
                                            me.$message({
                                                type: 'warning',
                                                message: '員工在一個組別中只能擁有一個角色,請重新選擇！'
                                            });
                                        }
                                        // this.disablePost = false;
                                        return false;
                                    }
                                }
                            }
                        }
                        if (this.isPass === true) {
                            const submitData = {
                              ...this.ruleForm,
                              // 如果 email 是 null/undefined，则赋予空字符串
                              email: this.ruleForm.email || '' 
                            };
                            this.axios.post(this.pub.getApi().UpdateUserInfo, submitData).then(async res => {
                                if (res.data.code === 0) {
                                    await this.$message({
                                        type: 'success',
                                        message: '操作成功!',
                                        showClose: true
                                    });
                                    //  && (this.remainderDiamond || this.remainderPropertyCoin)
                                    // && ((this.userDetail.remainderDiamond || this.userDetail.remainderPropertyCoin))
                                    // for (var i = 0; i < this.ruleForm.roleIDList.length; i++) {
                                    if(this.accountType && res.data.result.isRecycled){
                                        await this.$message({
                                            type: 'success',
                                            message: '原有角色的金幣/鑽石已回收到公司賬戶',
                                            showClose: true
                                        });
                                        // break;
                                    }
                                    if(!this.accountType && res.data.result.isRecycled){
                                        await this.$message({
                                            type: 'success',
                                            message: '原有角色的金幣/鑽石已回收到所屬組別賬戶',
                                            showClose: true
                                        });
                                        // break;
                                    }
                                    // }
                                    // 营业助理改为放盘人 显示提示
                                    if (this.mustEmail == true && this.isYingye == true && this.ruleForm.email !== '') {
                                        const confirmText = ['新增成功', '首次登入密碼會以電郵通知'];
                                        const newDatas = [];
                                        const h = this.$createElement;
                                        // eslint-disable-next-line no-shadow
                                        for (const i in confirmText) {
                                            newDatas.push(h('p', null, confirmText[i]));
                                        }
                                        this.$confirm('提示', {
                                            title: '提示',
                                            message: h('div', null, newDatas),
                                            showCancelButton: false,
                                            confirmButtonText: '確定',
                                            type: 'success'
                                        });
                                    }
                                    this.repeatEmail = false
                                    // this.disablePost = false;
                                    this.$router.push({
                                        name: this.pub.routeNameLists.StaffingIndex,
                                        params:this.$route.params
                                    });
                                } else if (res.data.code === 2032) {
                                    this.repeatEmail = false
                                    // this.disablePost = false;
                                    if (document.getElementsByClassName('el-message').length === 0) {
                                        this.$message({
                                            type: 'error',
                                            message: '員工在原組別角色下擁有金幣或樓盤，修改失敗!',
                                            showClose: true
                                        });
                                    }
                                } else if (res.data.code === 1308) {
                                    this.repeatEmail = false
                                    // this.disablePost = false;
                                    if (document.getElementsByClassName('el-message').length === 0) {
                                        this.$nextTick(()=>{
                                            this.repeatEmail = true
                                            // this.$refs.ruleForm.validateField('email')
                                        })
                                        this.$message({
                                            type: 'error',
                                            message:`${this.ruleForm.email}該電郵地址已註冊，請使用其他電郵地址。`,
                                            showClose: true
                                        });
                                    }
                                } else if (res.data.code === 2034) {
                                    this.repeatEmail = false
                                    // this.disablePost = false;
                                    if (document.getElementsByClassName('el-message').length === 0) {
                                        this.$message({
                                            type: 'error',
                                            message: '該員工擁有代理樓盤，不允許修改！',
                                            showClose: true
                                        });
                                    }
                                    return false;
                                } else if (res.data.code === 1309) {
                                    this.repeatEmail = false
                                    // this.disablePost = false;
                                    if (document.getElementsByClassName('el-message').length === 0) {
                                        this.$message({
                                            type: 'error',
                                            message: '電話重複，請重新輸入！',
                                            showClose: true
                                        });
                                    }
                                }
                            });
                        }
                    }
                } else {
                    this.repeatEmail = false
                    if (document.getElementsByClassName('el-message').length === 0) {
                        // this.disablePost = false;
                        this.$message({
                            type: 'warning',
                            message: '請完善信息!',
                            showClose: true
                        });
                    }
                }
            });
        },
        // 检查权限
        checkJurisdiction(departmentID, roleID, organizationOptions) {
            if (this.userInfo.accountID === this.ruleForm.accountID) {
                this.department = true;
                this.role = true;
            } else {
                for (var i = 0; i < organizationOptions.length; i++) {
                    if (departmentID === organizationOptions[i].departmentID) {
                        this.department = true;
                    } else if (organizationOptions[i].childNode && organizationOptions[i].childNode.length > 0) {
                        this.checkJurisdiction(departmentID, roleID, organizationOptions[i].childNode);
                    }
                }
                for (var j = 0; j < this.roleOptions.length; j++) {
                    if (roleID === this.roleOptions[j].roleID) {
                        this.role = true;
                    }
                }
            }
        },
        // 返回
        getBack() {
            if(this.viewMode == 'edit'){
                this.$router.push({
                    name: this.pub.routeNameLists.StaffingIndex,
                    params:this.$route.params
                });
            }else{
                this.$router.push({ path: '/staffing/index' });
            }
        },
        // 組別角色選擇限制
        handleChange(editIndex) {
            // 修改员工时切换组别
            var me = this;
            // 验证有无金币和楼盘
            if (me.viewMode === 'edit') {
                this.axios
                    .post(this.pub.getApi().UserDepartmentCionPropertyCount, {
                        accountID: me.ruleForm.accountID,
                        departmentID: me.detail.roleList[editIndex].accountDepartmentID
                    })
                    .then(res => {
                        if (res.data.code === 0 && res.data.result) {
                            // res.data.result.cionCount > 0 ||
                            if (res.data.result.propertyCount > 0 || res.data.result.agentPropertyCount > 0) {
                                if (document.getElementsByClassName('el-message').length === 0) {
                                    // 金幣或
                                    this.$message({
                                        type: 'warning',
                                        message: '員工在原組別角色下擁有樓盤，不允許切換！',
                                        showClose: true
                                    });
                                }
                                // eslint-disable-next-line no-shadow
                                var me = this;
                                me.roleIDList[editIndex].accountDepartmentID = me.detail.roleList[editIndex].accountDepartmentID;
                                me.userInfo.roleID;
                                me.roleIDList[editIndex].roleID = me.detail.roleList[editIndex].roleID;
                                me.setRole = me.detail.roleList[editIndex].roleName;
                                return false;
                            }
                                var me = this;
                                me.getCascaderNodes(); //监听值发生变化就关闭它
                                if (me.roleIDList.length >= 1) {
                                    for (var i = 0; i < me.roleIDList.length; i++) {
                                        for (var j = i + 1; j < me.roleIDList.length; j++) {
                                            if (me.roleIDList[i].accountDepartmentID == me.roleIDList[j].accountDepartmentID && me.roleIDList[i].accountDepartmentID !== null && me.roleIDList[j].accountDepartmentID !== null) {
                                                if (document.getElementsByClassName('el-message').length === 0) {
                                                    me.$message({
                                                        type: 'warning',
                                                        message: '員工在一個組別中只能擁有一個角色,請重新選擇！',
                                                        showClose: true
                                                    });
                                                }
                                                return false;
                                            }
                                        }
                                        // 当length长度小于1时候
                                        if (this.viewMode === 'edit') {
                                            // this.accountType && (this.userInfo.roleID == 1 || this.userInfo.roleID == 2) &&
                                            // 公司账户 选择了放盘人
                                            // 個人帳戶（被修改組別的人是: 放盤人﹑分行管理員﹑總行管理員）
                                            let showSuc= false
                                            let mes = ''
                                            if((this.accountType && (this.userInfo.roleID == 1 || this.userInfo.roleID == 2) && this.roleIDList[editIndex].roleID == 3)){
                                                showSuc = true
                                                mes = '在左下方點儲存後，原有角色的金幣/鑽石將會回收到公司賬戶'
                                            }
                                            //  && ((this.userDetail.remainderDiamond || this.userDetail.remainderPropertyCoin))
                                            if(!this.accountType && this.roleIDList[editIndex].roleID !== 4){
                                                showSuc = true
                                                mes = '在左下方點儲存後，原有角色的金幣/鑽石將會回收到所屬組別賬戶'
                                            }
                                            if(showSuc){
                                                this.$confirm(`${mes}`, '修改組別提示', {
                                                    confirmButtonText: '修改組別',
                                                    cancelButtonText: '取消',
                                                    type: 'warning'
                                                })
                                                    .then(() => {
                                                        this.showFlag = true;
                                                    })
                                                    .catch(() => {
                                                        me.roleIDList[editIndex].accountDepartmentID = me.detail.roleList[editIndex].accountDepartmentID;
                                                        me.userInfo.roleID;
                                                        me.roleIDList[editIndex].roleID = me.detail.roleList[editIndex].roleID;
                                                        me.setRole = me.detail.roleList[editIndex].roleName;
                                                        this.showFlag == false;
                                                    });
                                            }
                                        }
                                        if (this.showFlag == true) {
                                            var me = this;
                                            if (me.roleIDList[editIndex].roleID === me.userInfo.roleID) {
                                                me.roleIDList[editIndex].roleID = me.setRole;
                                            }
                                            if (me.roleIDList[i].roleID == 4) {
                                                this.ruleForm.isAgent = true;
                                            }
                                            me.checkNoAgent = false;
                                            if (me.roleIDList[i].roleID !== 4) {
                                                me.checkNoAgent = true;
                                                return;
                                            }
                                        }
                                    }
                                }

                        }
                    });
            } else if (this.viewMode === 'create') {
                // 不选组别仅选择营业助理时 默认选中是代理人
                // 初始进入邮箱为需要校验 选中营业助理为非校验
                for (let k = 0; k < this.ruleForm.roleIDList.length; k++) {
                    if (this.ruleForm.roleIDList[k].roleID == 4) {
                        this.ruleForm.isAgent = true;
                    }
                    if (editIndex === 'role' && this.ruleForm.roleIDList[k].roleID == 4) {
                        this.chushijin = false;
                    }
                }
                this.getCascaderNodes(); //监听值发生变化就关闭它
                // 营业代理 roleid:4
                if (this.ruleForm.roleIDList.length >= 1) {
                    for (var i = 0; i < this.ruleForm.roleIDList.length; i++) {
                        for (var j = i + 1; j < this.ruleForm.roleIDList.length; j++) {
                            if (this.ruleForm.roleIDList[i].departmentID == this.ruleForm.roleIDList[j].departmentID && this.ruleForm.roleIDList[i].departmentID !== null && this.ruleForm.roleIDList[j].departmentID !== null) {
                                if (document.getElementsByClassName('el-message').length === 0) {
                                    this.$message({
                                        type: 'warning',
                                        message: '員工在一個組別中只能擁有一個角色,請重新選擇！',
                                        showClose: true
                                    });
                                }
                                return false;
                            }
                        }

                        if (editIndex === 'role') {
                            this.checkNoAgent = false;
                            if (this.ruleForm.roleIDList[i].roleID !== 4) {
                                this.checkNoAgent = true;
                                return;
                            }
                        }
                    }
                }
            }
        },
        // 修改员工状态
        updtaeStatus() {
            var me = this;
            me.roleIDList.forEach(element => {
                me.department = false;
                me.role = false;
                me.checkJurisdiction(element.accountDepartmentID, element.roleID, this.organizationOptions);
            });
            if (me.department === false || me.role === false) {
                me.ruleForm.status = me.check;
                if (document.getElementsByClassName('el-message').length === 0) {
                    me.$message({
                        type: 'error',
                        message: '該員工所在組別或角色級別較高，無權限操作！'
                    });
                }
                return false;
            }
        },
        newHandleChange() {
            this.getCascaderNodes();
            for (let i = 0; i < this.newRuleForm.newRoleIDList.length; i++) {
                if (this.newRuleForm.newRoleIDList.length > 1 && this.newRuleForm.newRoleIDList[i].accountDepartmentID !== undefined) {
                    if (this.newRuleForm.newRoleIDList[i + 1]) {
                        if (this.newRuleForm.newRoleIDList[i].accountDepartmentID == this.newRuleForm.newRoleIDList[i + 1].accountDepartmentID && this.newRuleForm.newRoleIDList[i].accountDepartmentID !== null && this.newRuleForm.newRoleIDList[i + 1].accountDepartmentID !== null && this.newRuleForm.newRoleIDList[i + 1].accountDepartmentID && this.newRuleForm.newRoleIDList[i].accountDepartmentID !== undefined) {
                            if (document.getElementsByClassName('el-message').length === 0) {
                                this.$message({
                                    type: 'warning',
                                    message: '員工在一個組別中只能擁有一個角色,請重新選擇！',
                                    showClose: true
                                });
                            }
                            return false;
                        }
                    } else {
                        for (let j = 0; j < this.roleIDList.length; j++) {
                            if (this.newRuleForm.newRoleIDList[i].accountDepartmentID == this.roleIDList[j].accountDepartmentID) {
                                if (document.getElementsByClassName('el-message').length === 0) {
                                    this.$message({
                                        type: 'warning',
                                        message: '員工在一個組別中只能擁有一個角色,請重新選擇！',
                                        showClose: true
                                    });
                                }
                                return false;
                            }
                        }
                    }
                } else {
                    for (let j = 0; j < this.roleIDList.length; j++) {
                        if (this.newRuleForm.newRoleIDList[i].accountDepartmentID == this.roleIDList[j].accountDepartmentID) {
                            if (document.getElementsByClassName('el-message').length === 0) {
                                this.$message({
                                    type: 'warning',
                                    message: '員工在一個組別中只能擁有一個角色,請重新選擇！',
                                    showClose: true
                                });
                            }
                            return false;
                        }
                    }
                }
                var me = this;
                if (me.newRuleForm.newRoleIDList[i].roleID == 4) {
                    this.ruleForm.isAgent = true;
                }
                me.checkNoAgent = false;
                if (me.newRuleForm.newRoleIDList[i].roleID !== 4) {
                    me.checkNoAgent = true;
                    return;
                }
            }
        },
        // 新增一行
        addRow(row) {
            if (this.viewMode === 'create') {
                this.ruleForm.roleIDList.push({
                    roleID: null,
                    departmentID: null
                });
            } else if (this.viewMode === 'edit') {
                if (this.showRow === false) {
                    this.showRow = true;
                }
                this.newRuleForm.newRoleIDList.push({
                    roleID: null,
                    departmentID: null
                });
            }
            for (let i = 0; i < this.ruleForm.roleIDList.length; i++) {
                if (this.ruleForm.roleIDList[i].roleID == 4) {
                    this.ruleForm.isAgent = true;
                }
            }
        },
        // 刪除一行
        deleteRow(val, index) {
            if (typeof index === 'string') {
                index = parseInt(index);
            }
            if (this.viewMode === 'create') {
                this.ruleForm.roleIDList.splice(index, 1);
                for (let i in this.list) {
                    this.list[i].index = i;
                }
                // 判断代理人
                this.checkNoAgent = false;
                for (var i = 0; i < this.ruleForm.roleIDList.length; i++) {
                    if (this.ruleForm.roleIDList[i].roleID !== 4) {
                        this.checkNoAgent = true;
                        return;
                    }
                }
            } else if (this.viewMode === 'edit') {
                if (val.examine === 1) {
                    // 验证有无金币楼盘
                    this.axios
                        .post(this.pub.getApi().UserDepartmentCionPropertyCount, {
                            accountID: this.ruleForm.accountID,
                            departmentID: val.accountDepartmentID
                        })
                        .then(res => {
                            if (res.data.code === 0 && res.data.result) {
                                if (res.data.result.cionCount > 0 || res.data.result.propertyCount > 0 || res.data.result.agentPropertyCount > 0) {
                                    if (document.getElementsByClassName('el-message').length === 0) {
                                        this.$message({
                                            type: 'error',
                                            message: '員工在原組別角色下擁有金幣或樓盤，不允許刪除！',
                                            showClose: true
                                        });
                                    }
                                    return false;
                                }
                                    this.roleIDList.splice(index, 1);
                                    for (let i in this.list) {
                                        this.list[i].index = i;
                                    }
                                    // 判断代理人
                                    var me = this;
                                    me.checkNoAgent = false;
                                    // eslint-disable-next-line no-shadow
                                    for (var i = 0; i < me.roleIDList.length; i++) {
                                        if (me.roleIDList[i].roleID !== 4) {
                                            me.checkNoAgent = true;
                                            return;
                                        }
                                    }

                            }
                        });
                } else {
                    this.newRuleForm.newRoleIDList.splice(index, 1);
                    // eslint-disable-next-line no-shadow
                    for (let i in this.list) {
                        this.list[i].index = i;
                    }
                    if (this.newRuleForm.newRoleIDList.length === 0) {
                        this.showRow = false;
                    }
                    // 判断代理人
                    var me = this;
                    me.checkNoAgent = false;
                    for (var i = 0; i < me.newRuleForm.newRoleIDList.length; i++) {
                        if (me.newRuleForm.newRoleIDList[i].roleID !== 4) {
                            me.checkNoAgent = true;
                            return;
                        }
                    }
                }
            }
        },
        /* 判断级联选择器是否有子节点 */
        getCascaderNodes() {
            var cascaderNodes = this.$refs.cascader[0].getCheckedNodes();
            if (cascaderNodes[0].children.length === 0) {
                this.$refs.cascader[0].dropDownVisible = false;
            }
        },
        // 判断角色（代理）
        handleAvatarSuccess() {
            this.$refs.ruleForm.clearValidate('image');
            this.hasFmt = true;
        },
        // 头像上传
        beforeAvatarUpload(source) {
            if(source == 'weChatQRCode' && (!this.ruleForm.weChatNo || this.ruleForm.weChatNo.length<6 || this.ruleForm.weChatNo.length>20 )){return}
            this.upSource = source
            this.openAvatar = true;
            source == 'weChatQRCode' ? this.titleAvatar = '上傳WeChat二維碼': source == "agentCardPath" ? this.titleAvatar = '上傳代理證':this.titleAvatar = '上傳頭像'
            this.loadingAvatar = false;
            this.fileUrl = null;
        },
        uploadAvatar() {
            this.loadingAvatar = true;
            //将文件转化为formdata数据
            let formData = new FormData();
            formData.append('file', this.fileUrl, this.fileName);
            // post上传
            this.axios
                .post(this.pub.getApi().Upload, formData)
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        let uploadSource = this.upSource == 'userImage' ? 'imagePath' :this.upSource == 'agentCardPath'? 'agentCardPath': 'weChatQRCode'
                        this.ruleForm[uploadSource] = res.data.result[0].url;
                        this.$message({
                            message: this.upSource == 'userImage'?'頭像上傳成功！': this.upSource == 'agentCardPath' ? '代理證上傳成功':'WeChat二維碼上傳成功！',
                            type: 'success',
                            showClose: true
                        });
                        this.openAvatar = false;
                        this.loadingAvatar = false;
                        this.fileUrl = null;
                        this.$refs.upImg.resetFile();
                    }
                })
                .catch(error => {
                    this.loadingAvatar = false;
                    let errorMes = this.upSource == 'userImage'?'頭像上傳失敗，請重新上傳！' :  this.upSource == 'userImage' ? '代理證上傳失敗，請重新上傳':'WeChat二維碼上傳失敗，請重新上傳！'
                    this.$message.error(errorMes);
                });
        }
    }
};
</script>
<style lang="less" scoped>
.staffing-container {
    text-align: left;
    font-family: PingFangSC-Regular, PingFang SC;
    .title {
        margin: 0 0 20px 0;
        font-size: 24px;
        padding-bottom: 20px;
        border-bottom: 1px solid #e2e2ea;
    }
    .btn .el-button {
        border: none;
        border-radius: 10px;
    }
    .edit-text-show {
        /deep/ .el-dialog {
            max-height: 600px;
            .el-dialog__header {
                font-weight: 600;
            }
            .el-dialog__body {
                max-height: 420px;
                overflow: auto;
                .el-row-dialog {
                    text-align: center;
                }
                .el-checkbox__input.is-checked .el-checkbox__inner {
                    background-color: #0064ff;
                    border-color: #0064ff;
                }
                .el-row-dialog.el-row {
                    background: rgba(80, 181, 255, 0.15);
                    border-radius: 10px;
                    line-height: 38px;
                }
                .el-list.el-row {
                    text-align: center;
                    line-height: 46px;
                    .el-list-div {
                        overflow: hidden;
                        border-bottom: 1px solid #efefef;
                    }
                    p {
                        line-height: 28px;
                    }
                }
            }
        }
    }
    .detail-container {
        width: 660px;
        .winput{
            width:555px;
            margin-left:10px
        }
        .span_errtxt{
            position: absolute;
            color: #E50113;
            font-size: 14px;
            min-width: 252px;
            line-height: 19px;
            margin-left: 10px;
        }
        .wcheck {
            position: absolute;
            margin-left: 16px;
        }
        .w600 {
            width: 800px;
        }
        .w84{
            width:84px
        }
        /deep/.w601 {
            width: 800px;
            .el-form-item__label {
                line-height: 20px;
                white-space: pre-line;
            }
        }
        .w180 {
            width: 262px;
        }
        .actionRow {
            margin-left: 10px;
            position: absolute;
            height: 40px;
            width: 40px;
        }
        .actionRowDel {
            margin-left: 60px;
            position: absolute;
            height: 40px;
            width: 40px;
        }
        .photoTip {
            line-height: 20px;
            display: inline-block;
            color: #989898;
        }
        .none{
            cursor: not-allowed !important;
        }
        .avatar-uploader {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            width: 100px;
            height: 100px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
            border-color: #409eff;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 100px;
            height: 100px;
            line-height: 100px;
            text-align: center;
        }
        .w160 {
            width: 300px;
        }
        .avatar {
            width: 100px;
            height: 100px;
            display: block;
        }
        .explain {
            padding: 10px 0;
        }
    }
    // ---------------------------UI优化
    /deep/ .el-input__inner,
    /deep/.el-textarea__inner {
        color: #000000;
        font-family: PingFangSC-Regular, PingFang SC;
        &::placeholder {
            font-size: 14px;
            color: #666666;
        }
    }
}
</style>
